export const toIsoDuration = data => {
  const [s = 0, m = 0, h = 0] = data.split(':').reverse().map(Number);

  const parts = [h && `${h}H`, m && `${m}M`, s && `${s}S`].filter(Boolean);

  return `PT${parts.join('')}` || 'PT0S';
};
